UC.views.MultiFactorAuthRequestDisable = Backbone.View.extend({
    initialize: function() {
        new UC.partials.SessionSudoForm({el: this.$el})
    }
});
